import { expected, orUndefined, schUnitRateModels } from '@aloft/toolkit-shared';
import { Flex, Icon, Typography, colors } from '@aloft/toolkit-sui';
// eslint-disable-next-line aloft/no-direct-chakra, aloft/prefer-sound-ui-button, import/no-extraneous-dependencies
import {
  Modal as ChakraModal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
} from '@chakra-ui/react';

import { useParams } from 'react-router';

import { useGetTkv2UnitRateModelsAPI } from '../../../hooks/api/toolkitComponents.ts';
import { RegressionModalFeatureTable } from './RegressionModalFeatureTable.tsx';
import { RegressionModalGraphSection } from './RegressionModalGraphSection.tsx';
import { StatsRow } from './StatsRow.tsx';

export const RegressionAnalysisModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const orderID = expected(useParams().orderId);

  const unitRateModelsQuery = useGetTkv2UnitRateModelsAPI(
    { pathParams: { orderID } },
    { staleTime: Infinity },
  );

  const regression = orUndefined(schUnitRateModels.parse)(
    unitRateModelsQuery.data?.body,
  )?.regression;
  const output = regression?.status === 'success' ? regression.output : undefined;

  return (
    <ChakraModal isOpen={isOpen} onClose={onClose} scrollBehavior="inside" size="6xl" isCentered>
      <ModalOverlay />
      <ModalContent bg={colors.surface3} onKeyDown={(e) => e.stopPropagation()}>
        <ModalCloseButton />
        <ModalBody padding="1.5rem">
          <Flex flexDirection="column" gap="1rem">
            <Flex alignItems="center" gap="0.75rem">
              <Icon icon="line-chart" size="xl" />
              <Typography variant="h1">Regression Analysis Model</Typography>
            </Flex>

            <Typography variant="body2" color="textSecondary">
              Toolkit&apos;s regression model is built using a sample of the 150 most proximate
              properties to the Subject that sold within the past 12 months.
            </Typography>

            {output && (
              <>
                <StatsRow type="regression" output={output} />
                <RegressionModalFeatureTable output={output} />
                <RegressionModalGraphSection output={output} />
              </>
            )}

            {!output && (
              <Typography variant="body2" color="textSecondary">
                Regression model data is not available.
              </Typography>
            )}
          </Flex>
        </ModalBody>
      </ModalContent>
    </ChakraModal>
  );
};
